module.exports = __webpack_public_path__ + "img/328.609f778a.jpg";